import { get, post, put, del } from '@/js/api/sourcer';
import STATUS from '@/store/status';
import Vue from 'vue';
import consola from 'consola';
import Config from '@/js/config';
import * as Sentry from '@sentry/vue';

const SET_CANDIDATES = 'SET_CANDIDATES';
const SET_STATUS = 'SET_STATUS';
const SET_PROGRESS = 'SET_PROGRESS';

const MOVE_NEXT = 'MOVE_NEXT';
const MOVE_PREV = 'MOVE_PREV';
const UPDATE_CANDIDATE = 'UPDATE_CANDIDATE';
const UPDATE_CANDIDATE_STATE = 'UPDATE_CANDIDATE_STATE';
const SET_WARMLEADS_TEMPLATE = 'SET_WARMLEADS_TEMPLATE';

const SET_SUCCESS_MESSAGE = 'SET_SUCCESS_MESSAGE';
const SET_IS_SUCCESS = 'SET_IS_SUCCESS';
const SET_IS_LOADING = 'SET_IS_LOADING';
const SET_CANDIDATE_RESPONSE_DATA = 'SET_CANDIDATE_RESPONSE_DATA';
const UPDATE_EMAIL_HISTORY = 'UPDATE_EMAIL_HISTORY';

const State = {
  candidates: {},
  progress: {},
  status: {},
  warmLeadsTemplate: {},
  successMessage: '',
  isSuccess: false,
  isLoading: false,
  candidateResponseData: {},
};

const helpers = {
  setValue(map, projectId, tab, value) {
    if (!map[projectId]) {
      Vue.set(map, projectId, {});
    }
    Vue.set(map[projectId], tab, value);
  },
};

// getters
const Getters = {
  listCandidates: (state) => (projectId, tab) => {
    if (state.candidates[projectId]) {
      return state.candidates[projectId][tab];
    }
    return [];
  },
  listCadidatePaging: (state, getters) => (projectId, tab, page, limit) => {
    let result = [];
    if (
      state.candidates[projectId] &&
      (getters.getStatus(projectId, tab) === STATUS.LOADED ||
        getters.getStatus(projectId, tab) === STATUS.STALE)
    ) {
      const arr =
        state.candidates &&
        state.candidates[projectId] &&
        state.candidates[projectId][tab]
          ? state.candidates[projectId][tab]
          : [];
      result = arr.filter(
        (item, i) => i >= (page - 1) * limit && i < (page - 1) * limit + limit
      );
    }
    return result;
  },

  getPaging: (state, getters) => (projectId, tab, id, limit) => {
    let arr = [];
    if (
      state.candidates[projectId] &&
      (getters.getStatus(projectId, tab) === STATUS.LOADED ||
        getters.getStatus(projectId, tab) === STATUS.STALE)
    ) {
      arr = state.candidates[projectId][tab];
    }
    let ind = 0;
    arr.forEach((item, i) => {
      if (item.id === id) {
        ind = i;
      }
    });

    return Math.floor(ind / limit) + (ind % limit >= 0 ? 1 : 0);
  },

  getStatus: (state) => (projectId, tab) => {
    if (!state.status[projectId] || !state.status[projectId][tab]) {
      return STATUS.NOT_LOADED;
    }
    const tabs = state.status[projectId];
    return tabs[tab] || STATUS.NOT_LOADED;
  },

  getProgress: (state) => (projectId) => state.progress[projectId],
  getWarmLeadsTemplate: (state) => state.warmLeadsTemplate,
  getSuccessMessage: (state) => state.successMessage,
  getIsSuccess: (state) => state.isSuccess,
  getIsLoading: (state) => state.isLoading,
  candidateResponseData: (state) => state.candidateResponseData,
};

// mutations
const Mutations = {
  [SET_CANDIDATES](state, { projectId, tab, candidates = [] }) {
    helpers.setValue(state.candidates, projectId, tab, candidates);
    helpers.setValue(state.status, projectId, tab, STATUS.LOADED);
  },
  [SET_STATUS](state, { projectId, tab, status }) {
    helpers.setValue(state.status, projectId, tab, status);
  },
  [MOVE_NEXT](state, { projectId, tab }) {
    const candidates = state.candidates[projectId][tab];
    const { length } = candidates || [];
    if (length < 1) {
      return;
    }

    const lastCandidate = candidates.slice(length - 1);
    const rest = candidates.slice(0, length - 1);
    state.candidates[projectId][tab] = lastCandidate.concat(rest);
  },
  [MOVE_PREV](state, { projectId, tab }) {
    const candidates = state.candidates[projectId][tab];
    const { length } = candidates || [];
    if (length < 1) {
      return;
    }

    const firstCandidate = candidates.slice(0, 1);
    const rest = candidates.slice(1);
    state.candidates[projectId][tab] = rest.concat(firstCandidate);
  },
  [UPDATE_CANDIDATE_STATE](state, { projectId, tab, candidateId, newTab }) {
    const currentTabCandidates = state.candidates[projectId][tab];
    const candidate = currentTabCandidates.find(
      (item) =>
        item._id === candidateId || item.core_candidate_id === candidateId
    );
    state.candidates[projectId][tab] = currentTabCandidates.filter(
      (item) =>
        item._id !== candidateId && item.core_candidate_id !== candidateId
    );
    const newTabCandidates = state.candidates[projectId][newTab];
    if (!newTabCandidates) {
      // New tab is not loaded yet. No need to run the local operation.
      return;
    }

    newTabCandidates.push(candidate);
    state.candidates[projectId][newTab] = newTabCandidates;
    state.candidates = { ...state.candidates };
  },
  [SET_PROGRESS](state, { projectId, progress, is_calibration }) {
    consola.info(`Set Progress ${projectId} to ${progress}%`);
    if (progress > 100) {
      return;
    }
    Vue.set(state.progress, projectId, [progress, is_calibration]);
  },
  [UPDATE_CANDIDATE](state, { candidate, field, value }) {
    Vue.set(candidate, field, value);
  },
  [SET_WARMLEADS_TEMPLATE](state, { value }) {
    state.warmLeadsTemplate = value;
  },
  [SET_SUCCESS_MESSAGE](state, { value }) {
    state.successMessage = value;
    state.isSuccess = true;
  },
  [SET_IS_SUCCESS](state, { value }) {
    state.isSuccess = value;
  },
  [SET_IS_LOADING](state, { value }) {
    state.isLoading = value;
  },

  [SET_CANDIDATE_RESPONSE_DATA](state, value) {
    state.candidateResponseData = value;
  },

  [UPDATE_EMAIL_HISTORY](state, value) {
    state.email_history = value;
  },
};

function maybeMoveSpecifiedCandidateToEnd(arr, tab, id) {
  if (
    id &&
    [
      'WARM_LEADS_HM',
      'HIRING_MANAGER',
      'AUTOPILOT_RECRUITER',
      'WARM_LEADS_RECRUITER',
      'WARM_LEADS_QUESTION',
      'QUESTION',
    ].includes(tab)
  ) {
    let tmp2 = null;
    let ind = null;
    if (!arr) return [];
    arr.forEach((item, i) => {
      if (id === item._id) {
        tmp2 = item;
        ind = i;
      }
    });
    if (tmp2) {
      arr.splice(ind, 1);
      arr.push(tmp2);
    }
  }
  return arr;
}

const ensureUserLoaded = async (rootState, dispatch) => {
  if (rootState.user.status === STATUS.NOT_LOADED) {
    await dispatch('user/LOAD');
  } else if (rootState.user.status === STATUS.LOADING) {
    await rootState.user.operation;
  }
  return true;
};

// actions
const Actions = {
  async loadQueueCandidate(context, { projectId, calibration }) {
    if (!projectId) return;
    const tab = 'UNDER_REVIEW';

    context.commit(SET_STATUS, {
      projectId,
      tab,
      status: STATUS.LOADING,
    });
    const payload = { project_id: projectId, is_calibration: calibration };
    try {
      const res = await get(
        `${Config.env.API_URL_V2}projects/candidates/queue?project_id=${projectId}&is_calibration=${calibration}`,
        payload
      );
      if (res && res.status === 200) {
        const arr = res.data ? [res.data] : [];
        context.commit(SET_CANDIDATES, {
          projectId,
          tab,
          candidates: arr,
        });
      }
    } catch (e) {
      Sentry.captureException(e);
      context.commit(SET_STATUS, { projectId, tab, status: STATUS.NOT_LOADED });
    }
  },

  async loadCandidates(
    context,
    { projectId, tab, force, tmp, id, pageIdx = 1 }
  ) {
    if (!projectId || !tab) {
      return;
    }
    if (
      context.rootGetters['projects/getProjectById'](projectId) &&
      context.rootGetters['projects/getProjectById'](projectId).type === '2' &&
      this.tab === 'UNDER_REVIEW'
    ) {
      await context.dispatch('loadQueueCandidate', {
        projectId,
        calibration: false,
      });
      return;
    }
    if (!tmp) {
      const status = context.getters.getStatus(projectId, tab);
      if ((status === STATUS.LOADING || status === STATUS.LOADED) && !force) {
        // Already loading or loaded. Do nothing.
        let arr = context.getters.listCandidates(projectId, tab);
        arr = maybeMoveSpecifiedCandidateToEnd(arr, tab, id);
        context.commit(SET_CANDIDATES, {
          projectId,
          tab,
          candidates: arr,
        });
        return;
      }
    }
    context.commit(SET_STATUS, { projectId, tab, status: STATUS.LOADING });
    try {
      await ensureUserLoaded(context.rootState, context.dispatch);
      let response;
      if (context.rootGetters['user/getIsUserV2']) {
        response = await get(
          `${Config.env.API_URL_V2}projects/candidates?project_id=${projectId}&status=${tab}&page_idx=${pageIdx}`
        );
      } else {
        response = await get(
          `${Config.env.API_URL}candidates?project_id=${projectId}&status=${tab}&page_idx=${pageIdx}`,
          true
        );
      }
      if (response && response.status === 200) {
        const arr = maybeMoveSpecifiedCandidateToEnd(response.data, tab, id);

        arr.map((candidate) => {
          return candidate.outreach_templates?.map((e) => {
            const item = e;
            let arr1 = [];
            if (item.initial_outreach_template) {
              item.initial_outreach_template = item.initial_outreach_template
                .replaceAll('<br>', '')
                .trim();
              arr1 = item.initial_outreach_template.split('\n\n');
              item.initial_outreach_template = '';
              arr1.forEach((element) => {
                if (element.length > 1) {
                  if (element.includes('<p')) {
                    item.initial_outreach_template += `${element.trim()}<br/>`;
                  } else {
                    item.initial_outreach_template += `<p>${element.trim()}</p><br/>`;
                  }
                }
              });
            }

            if (item.follow_up_1_template) {
              item.follow_up_1_template = item.follow_up_1_template
                .replaceAll('<br>', '')
                .trim();
              arr1 = item.follow_up_1_template.split('\n\n');
              item.follow_up_1_template = '';
              arr1.forEach((element) => {
                if (element.length > 1) {
                  if (element.includes('<p')) {
                    item.follow_up_1_template += `${element.trim()}<br/>`;
                  } else {
                    item.follow_up_1_template += `<p>${element.trim()}</p><br/>`;
                  }
                }
              });
            }

            if (item.follow_up_2_template) {
              item.follow_up_2_template = item.follow_up_2_template
                .replaceAll('<br>', '')
                .trim();
              arr1 = item.follow_up_2_template.split('\n\n');
              item.follow_up_2_template = '';
              arr1.forEach((element) => {
                if (element.includes('<p')) {
                  item.follow_up_2_template += `${element.trim()}<br/>`;
                } else {
                  item.follow_up_2_template += `<p>${element.trim()}</p><br/>`;
                }
              });
            }

            if (item.follow_up_3_template) {
              item.follow_up_3_template = item.follow_up_3_template
                .replaceAll('<br>', '')
                .trim();
              arr1 = item.follow_up_3_template.split('\n\n');
              item.follow_up_3_template = '';
              arr1.forEach((element) => {
                if (element.length > 1) {
                  if (element.includes('<p')) {
                    item.follow_up_3_template += `${element.trim()}<br/>`;
                  } else {
                    item.follow_up_3_template += `<p>${element.trim()}</p><br/>`;
                  }
                }
              });
            }
            return item;
          });
        });
        context.commit(SET_CANDIDATES, {
          projectId,
          tab,
          candidates: arr,
        });
      } else if (!tmp) {
        context.commit(SET_STATUS, { projectId, tab, status: STATUS.ERROR });
      }
    } catch (e) {
      Sentry.captureException(e);
      context.commit(SET_STATUS, { projectId, tab, status: STATUS.NOT_LOADED });
    }
  },

  async approveAndSend(
    context,
    {
      sender_override,
      candidate_id,
      project_id,
      email_subject,
      email_body,
      is_calibration,
      tab,
      candidateProjectId,
      email_type,
      email_override,
    }
  ) {
    if (
      !(
        sender_override ||
        candidate_id ||
        project_id ||
        email_subject ||
        email_body
      )
    ) {
      return false;
    }
    const newTab = 'APPROVED';
    try {
      context.commit(SET_IS_LOADING, { value: true });

      context.commit(SET_STATUS, { project_id, tab, status: STATUS.STALE });
      context.commit(SET_STATUS, {
        project_id,
        tab: newTab,
        status: STATUS.STALE,
      });
      let response;
      if (!candidateProjectId) {
        response = await post(
          `${Config.env.API_URL_V2}projects/candidates/approve_and_send`,
          {
            sender_override,
            candidate_id,
            project_id,
            email_subject,
            email_body,
            is_calibration,
            email_override,
          }
        );
      } else {
        response = await post(
          `${Config.env.API_URL_V2}projects/candidates/email`,
          {
            candidate_id,
            sender_override,
            project_id,
            email_subject,
            email_body,
            is_calibration,
            tab,
            email_type,
            email_override,
          }
        );
        if (response.status === 200 && !response.data.email_status) {
          response.data = {
            email_status: 200,
          };
          context.commit(UPDATE_CANDIDATE_STATE, {
            projectId: project_id,
            tab,
            candidateId: candidate_id,
            newTab: 'CONTACTED',
          });
        }
      }
      if (response.status !== 200) return response;
      context.commit(SET_IS_LOADING, { value: false });
      if (response && response.data && response.data.email_status === 200) {
        context.commit(
          `projects/${UPDATE_CANDIDATE_STATE}`,
          { projectId: project_id, tab, newTab: 'CONTACTED' },
          { root: true }
        );
        if (
          (!is_calibration || response.data.remaining_swipes > 0) &&
          tab === 'UNDER_REVIEW'
        ) {
          context.dispatch('loadQueueCandidate', {
            projectId: project_id,
            calibration: is_calibration,
          });
        }
      }
      return response;
    } catch (e) {
      Sentry.captureException(e);
      context.commit(SET_IS_LOADING, { value: false });
      if (e.toString().includes('417')) {
        return 417;
      }
      return e;
    }
  },

  async swipe(
    context,
    { projectId, tab, candidateId, approved, rejection_reasons, isCalibration }
  ) {
    if (!(projectId || tab || candidateId || approved)) return false;
    const newTab = approved ? 'APPROVED' : 'REJECTED';

    const is_calibration = isCalibration;

    try {
      context.commit(SET_IS_LOADING, { value: true });
      // Both current tab and approved tab data is stale.
      context.commit(SET_STATUS, { projectId, tab, status: STATUS.STALE });
      context.commit(SET_STATUS, {
        projectId,
        tab: newTab,
        status: STATUS.STALE,
      });

      const response = await post(
        `${Config.env.API_URL_V2}projects/candidates/swipe`,
        {
          project_id: projectId,
          is_calibration,
          candidate_id: candidateId,
          approved,
          rejection_reasons,
        }
      );
      if (response) {
        context.commit(UPDATE_CANDIDATE_STATE, {
          projectId,
          tab,
          candidateId,
          newTab,
        });
        context.commit(
          `projects/${UPDATE_CANDIDATE_STATE}`,
          { projectId, tab, newTab },
          { root: true }
        );

        if (response.data.remaining_swipes > 0) {
          context.dispatch('loadQueueCandidate', {
            projectId,
            calibration: is_calibration,
          });
        } else if (
          context.rootGetters['projects/getProjectById'](projectId).status ===
          '6'
        ) {
          context.commit(
            `projects/SET_PROJECT`,
            {
              projectId,
              project: { status: 2 },
            },
            { root: true }
          );
          context.commit(
            `projects/SET_STATUS`,
            { status: STATUS.STALE },
            { root: true }
          );
        }
        context.commit(SET_IS_LOADING, { value: false });
        return response.data.remaining_swipes;
      }

      return 0;
    } catch (e) {
      Sentry.captureException(e);
      context.commit(SET_IS_LOADING, { value: false });
      if (e.toString().includes('417')) {
        return 417;
      }
      return false;
    }
  },

  async approveCandidateHm(
    context,
    { project_id, candidate, approval_score, approval_comments }
  ) {
    if (!(project_id && candidate && approval_score && approval_comments))
      return false;

    try {
      context.commit(SET_IS_LOADING, { value: true });
      const tab = 'HIRING_MANAGER';
      const newTab = 'HIRING_MANAGER_APPROVED';
      // Both current tab and approved tab data is stale.
      context.commit(SET_STATUS, { project_id, tab, status: STATUS.STALE });
      context.commit(SET_STATUS, {
        project_id,
        tab: newTab,
        status: STATUS.STALE,
      });

      const response = await post(
        `${Config.env.API_URL_V2}projects/candidates/hm_review`,
        {
          approved: true,
          project_id,
          candidate_id: candidate.core_candidate_id,
          approval_score,
          approval_comments,
        }
      );
      if (response && response.status === 200) {
        context.commit(UPDATE_CANDIDATE_STATE, {
          projectId: project_id,
          tab,
          candidateId: candidate._id,
          newTab,
        });
        context.commit(
          `projects/${UPDATE_CANDIDATE_STATE}`,
          { projectId: project_id, tab, newTab, isV2: true },
          { root: true }
        );
      }
      context.commit(SET_IS_LOADING, { value: false });
      return response;
    } catch (e) {
      Sentry.captureException(e);
      context.commit(SET_IS_LOADING, { value: false });
      return false;
    }
  },

  async approveCandidateRecruiter(
    context,
    { project_id, candidate, email_cc, email_subject, email_body, email_to }
  ) {
    if (!(project_id && candidate && email_to)) return false;

    try {
      context.commit(SET_IS_LOADING, { value: true });
      const tab = 'AUTOPILOT_RECRUITER';
      const newTab = 'HIRING_MANAGER';
      // Both current tab and approved tab data is stale.
      context.commit(SET_STATUS, { project_id, tab, status: STATUS.STALE });
      context.commit(SET_STATUS, {
        project_id,
        tab: newTab,
        status: STATUS.STALE,
      });

      const response = await post(
        `${Config.env.API_URL_V2}projects/candidates/recruiter_review`,
        {
          approved: true,
          project_id,
          candidate_id: candidate.core_candidate_id,
          email_cc,
          email_subject,
          email_body,
          email_to,
        }
      );
      if (response && response.status === 200) {
        context.commit(UPDATE_CANDIDATE_STATE, {
          projectId: project_id,
          tab,
          candidateId: candidate._id,
          newTab,
        });
        context.commit(
          `projects/${UPDATE_CANDIDATE_STATE}`,
          { projectId: project_id, tab, newTab, isV2: true },
          { root: true }
        );
      }
      context.commit(SET_IS_LOADING, { value: false });
      return response;
    } catch (e) {
      Sentry.captureException(e);
      context.commit(SET_IS_LOADING, { value: false });
      return false;
    }
  },

  async rejectCandidate(
    context,
    { project_id, candidate, rejection_reasons, tab }
  ) {
    context.commit(SET_IS_LOADING, { value: true });
    // Both current tab and approved tab data is stale.
    context.commit(SET_STATUS, {
      projectId: project_id,
      tab,
      status: STATUS.STALE,
    });
    context.commit(SET_STATUS, {
      projectId: project_id,
      tab: 'REJECTED',
      status: STATUS.STALE,
    });
    context.commit(UPDATE_CANDIDATE, {
      candidate,
      field: 'processed',
      value: true,
    });
    context.commit(UPDATE_CANDIDATE, {
      candidate,
      field: 'rejection_code',
      value: Object.keys(rejection_reasons),
    });

    try {
      const url =
        tab === 'AUTOPILOT_RECRUITER'
          ? `${Config.env.API_URL_V2}projects/candidates/recruiter_review`
          : `${Config.env.API_URL_V2}projects/candidates/hm_review`;
      const response = await post(url, {
        project_id,
        candidate_id: candidate.core_candidate_id,
        approved: false,
        rejection_reasons,
      });
      if (response && response.status === 200) {
        context.commit(UPDATE_CANDIDATE_STATE, {
          projectId: project_id,
          tab,
          candidateId: candidate._id,
          newTab: 'REJECTED',
        });
        context.commit(
          `projects/${UPDATE_CANDIDATE_STATE}`,
          { projectId: project_id, tab, newTab: 'REJECTED', isV2: true },
          { root: true }
        );
      }
      context.commit(SET_IS_LOADING, { value: false });
      return response;
    } catch (e) {
      Sentry.captureException(e);
      context.commit(SET_IS_LOADING, { value: false });
      if (e.toString().includes('417')) {
        return 417;
      }
      return false;
    }
  },

  async keepCandidateNeedAdditionalInfo(
    context,
    { project_id, candidate, additional_info_type, tab }
  ) {
    try {
      context.commit(SET_IS_LOADING, { value: true });
      // Both current tab and approved tab data is stale.
      context.commit(SET_STATUS, {
        projectId: project_id,
        tab,
        status: STATUS.STALE,
      });
      context.commit(SET_STATUS, {
        projectId: project_id,
        tab: 'AWAITING_INFO',
        status: STATUS.STALE,
      });

      const response = await post(
        `${Config.env.API_URL_V2}projects/candidates/keep`,
        {
          candidate_id: candidate.core_candidate_id,
          project_id,
          additional_info_type,
        }
      );
      if (response && response.status === 200) {
        context.commit(UPDATE_CANDIDATE_STATE, {
          projectId: project_id,
          tab,
          candidateId: candidate._id,
          newTab: 'AWAITING_INFO',
        });
        context.commit(
          `projects/${UPDATE_CANDIDATE_STATE}`,
          { projectId: project_id, tab, newTab: 'AWAITING_INFO', isV2: true },
          { root: true }
        );
      }
      context.commit(SET_IS_LOADING, { value: false });
      return response;
    } catch (e) {
      Sentry.captureException(e);
      context.commit(SET_IS_LOADING, { value: false });
      return false;
    }
  },

  async moveCandidate(context, { projectId, tab, candidate, newTab }) {
    if (!projectId || !tab || !candidate || !newTab) return false;

    try {
      context.commit(SET_IS_LOADING, { value: true });
      // Both current tab and approved tab data is stale.
      context.commit(SET_STATUS, { projectId, tab, status: STATUS.STALE });
      context.commit(SET_STATUS, {
        projectId,
        tab: newTab,
        status: STATUS.STALE,
      });

      const response = await post(
        `${Config.env.API_URL_V2}projects/candidates/status`,
        {
          project_id: projectId,
          candidate_id: candidate.core_candidate_id,
          status: newTab,
        }
      );
      if (response && response.status === 200) {
        context.commit(UPDATE_CANDIDATE_STATE, {
          projectId,
          tab,
          candidateId: candidate._id,
          newTab,
        });
        context.commit(
          `projects/${UPDATE_CANDIDATE_STATE}`,
          { projectId, tab, newTab, isV2: true },
          { root: true }
        );
      }
      context.commit(SET_IS_LOADING, { value: false });
      return response;
    } catch (e) {
      Sentry.captureException(e);
      context.commit(SET_IS_LOADING, { value: false });
      if (e.toString().includes('417')) {
        return 417;
      }
      return false;
    }
  },

  async copyCandidate(
    context,
    { projectId, movingTabName, candidateId, movingProjectId, tab }
  ) {
    context.commit(SET_IS_LOADING, { value: true });
    try {
      await post(`${Config.env.API_URL}candidates/copy`, {
        candidate_id: candidateId,
        new_project_id: movingProjectId,
        new_status: movingTabName,
      });
      context.commit(
        `projects/${UPDATE_CANDIDATE_STATE}`,
        { projectId, tab, newTab: '' },
        { root: true }
      );
      context.commit(UPDATE_CANDIDATE_STATE, {
        projectId,
        tab,
        candidateId,
        newTab: '',
      });
      context.commit(SET_IS_LOADING, { value: false });
      return true;
    } catch (e) {
      Sentry.captureException(e);
      context.commit(SET_IS_LOADING, { value: false });
      return false;
    }
  },

  async updateCandidateState(
    context,
    { projectId, tab, candidateId, newTab, payload = {} }
  ) {
    if (!projectId || !tab || !candidateId || !newTab) {
      return false;
    }
    try {
      context.commit(SET_IS_LOADING, { value: true });
      // Both current tab and approved tab data is stale.
      context.commit(SET_STATUS, { projectId, tab, status: STATUS.STALE });
      context.commit(SET_STATUS, {
        projectId,
        tab: newTab,
        status: STATUS.STALE,
      });

      const response = await put(`${Config.env.API_URL}candidates`, {
        candidate_id: candidateId,
        status: newTab,
        ...payload,
      });

      if (response && response.status === 200) {
        context.commit(SET_CANDIDATE_RESPONSE_DATA, response.data ?? {});
        // Run the same operation locally to avoid loading again.
        context.commit(UPDATE_CANDIDATE_STATE, {
          projectId,
          tab,
          candidateId,
          newTab,
        });
        // Load the new tab. If the user navigates to the new tab, they will see the latest data.
        // Do not load the current tab, to avoid loading while user is interacting with the UI.
        await context.dispatch('loadCandidates', { projectId, newTab });
        // Add success message
        if (
          (tab === 'WARM_LEADS_HM' && newTab === 'WARM_LEADS_HM_APPROVED') ||
          (tab === 'HIRING_MANAGER' && newTab === 'HIRING_MANAGER_APPROVED')
        ) {
          context.commit(SET_IS_SUCCESS, { value: true });
          setTimeout(() => {
            context.commit(SET_IS_SUCCESS, { value: false });
          }, 3000);
          let message = '';
          if (response.data?.screener_has_calendar) {
            message = `Hirefly will coordinate with the candidate to schedule time on ${response.data.screener_first_name} ${response.data.screener_last_name}'s calendar.`;
          } else {
            message = `Hirefly will introduce ${response.data?.screener_first_name} ${response.data?.screener_last_name} to the candidate via email. ${response.data?.screener_first_name} ${response.data?.screener_last_name} can coordinate directly with the candidate to schedule the interview`;
          }
          context.commit(SET_SUCCESS_MESSAGE, { value: message });
        }
      }
      context.commit(
        `projects/${UPDATE_CANDIDATE_STATE}`,
        { projectId, tab, newTab },
        { root: true }
      );

      if (tab === 'UNDER_REVIEW') {
        const project =
          context.rootGetters['projects/getProjectById'](projectId) || {};
        // TODO(jeremiah): clean up below after v2 rollout
        const reviewCount = project.candidate_batch_count
          ? project.candidate_batch_count.UNDER_REVIEW
          : project.candidates_review_count || 0;
        const candidatesCount = context.getters.listCandidates(
          projectId,
          tab
        ).length;

        if (reviewCount > 0 && candidatesCount === 0) {
          // If there is more candidates to review, load the candidates into the review tab.
          await context.dispatch('loadCandidates', { projectId, tab });
        }
      }
      context.commit(SET_IS_LOADING, { value: false });
      context.commit(SET_IS_SUCCESS, { value: false });
      return response;
    } catch (e) {
      Sentry.captureException(e);
      context.commit(SET_IS_LOADING, { value: false });
      if (e.toString().includes('417')) {
        return 417;
      }
      return false;
    }
  },

  async createComment(context, { candidate, commentBody, assigneeEmail }) {
    const response = await post(`${Config.env.API_URL}comments`, {
      // eslint-disable-next-line no-underscore-dangle
      candidate_id: candidate._id,
      comment_body: commentBody,
      assignee_email: assigneeEmail,
    });

    context.commit(UPDATE_CANDIDATE, {
      candidate,
      field: 'comments',
      value: response.data,
    });

    return response;
  },

  async updateCandidateEmailHistory(context, { history }) {
    context.commit(UPDATE_EMAIL_HISTORY, {
      value: history,
    });
  },

  async updateComment(
    context,
    { candidate, commentId, commentBody, assigneeEmail, isResolved }
  ) {
    // eslint-disable-next-line no-underscore-dangle
    const response = await put(`${Config.env.API_URL}comments`, {
      // eslint-disable-next-line no-underscore-dangle
      candidate_id: candidate._id,
      comment_id: commentId,
      comment_body: commentBody,
      assignee_email: assigneeEmail,
      is_resolved: isResolved,
    });

    consola.info(response);

    context.commit(UPDATE_CANDIDATE, {
      candidate,
      field: 'comments',
      value: response.data,
    });
    return response;
  },

  async deleteComment(context, { candidate, commentId }) {
    // eslint-disable-next-line no-underscore-dangle
    const request = `${Config.env.API_URL}comments?candidate_id=${candidate._id}&comment_id=${commentId}`;
    const response = await del(request);

    consola.info(response);

    context.commit(UPDATE_CANDIDATE, {
      candidate,
      field: 'comments',
      value: response.data,
    });
  },

  async fetchWarmLeadsTemplate(context, { candidateId, projectId }) {
    context.commit(SET_WARMLEADS_TEMPLATE, {
      value: {},
    });
    context.commit(SET_IS_LOADING, { value: true });
    // TODO(jeremiah): clean this up after v2 rollout
    let request;
    try {
      if (context.rootGetters['user/getIsUserV2']) {
        request = `${Config.env.API_URL_V2}autopilot/send_to_hm_template?candidate_id=${candidateId}&project_id=${projectId}`;
      } else {
        request = `${Config.env.API_URL}warmleads/template?candidate_id=${candidateId}&template_type=hm`;
      }
      const response = await get(request);

      response.data.email_body = response.data.email_body.replace(
        'class="full-width-box"',
        'class="full-width-box" contentEditable="false"'
      );
      context.commit(SET_WARMLEADS_TEMPLATE, {
        value: response.data,
      });
    } catch (e) {
      console.log(e);
    }

    context.commit(SET_IS_LOADING, { value: false });
  },
};

export default {
  namespaced: true,
  state: State,
  getters: Getters,
  actions: Actions,
  mutations: Mutations,
};
